import { PermissionsEnum } from '@/auth/interfaces';
import { SaveMedidasProductoPage } from '../../shared/saveMedidasProducto';
import { useCheckPermissions } from '@/shared';

export interface CreateMedidasProductoPageInterface {}

const CreateMedidasProductosPage: React.FC<CreateMedidasProductoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_unidadmedida);

  return <SaveMedidasProductoPage titlePage="Crear Medidas de Producto" />;
};

export default CreateMedidasProductosPage;
